import { render, staticRenderFns } from "./AddUpdatesPopup.vue?vue&type=template&id=32fbc0be"
import script from "./AddUpdatesPopup.vue?vue&type=script&lang=js"
export * from "./AddUpdatesPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports